import { IComment } from "@mctypes/global.types";
import { useState } from "react";
import { FreeTextSearch, SingleComment } from "../../../../components";
import { useAppSelector } from "../../../../hooks";
import {
  PostProjectByProjectIdProjectdashboardNewsSearchApiResponse,
  usePostProjectByProjectIdProjectdashboardNewsSearchMutation,
} from "../../../../../openapi";

const NewsSearch: React.FC<{}> = () => {
  const projectId = useAppSelector((state) => state.adminReducer.project._id);
  const layoutId = useAppSelector((state) => state.projectDashboardReducer.activeLayout?._id);
  const [storedData, setStoredData] = useState<PostProjectByProjectIdProjectdashboardNewsSearchApiResponse | null>(null);
  const [searchNews, { isLoading }] = usePostProjectByProjectIdProjectdashboardNewsSearchMutation();

  const [selecetedUsers, setSelectedUsers] = useState<string[]>([]);

  const search = async (query: string) => {
    const result = await searchNews({
      projectId,
      body: { dashboardId: layoutId, query, users: selecetedUsers },
    }).unwrap();
    setStoredData(result ?? []);
  };

  const onModalClose = () => {
    setStoredData(null);
    setSelectedUsers([]);
  };


  const uniqUsers = [];

  const updateMultiFilterItemOption = (title: string, value: string) => {
    setSelectedUsers((prev) => {
      if (prev.includes(value)) {
        return prev.filter((item) => item !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  return (
    <div className="mb-1">
      {uniqUsers != null && (
        <FreeTextSearch
          placeholder="Søk"
          manualIsLoading={isLoading}
          search={search}
          onModalClose={onModalClose}
          displayNoResultsText={storedData != null && storedData?.length === 0 && isLoading === false}
          updateMultiFilterItemOption={updateMultiFilterItemOption}
          multipleFilterItems={[
            {
              title: "Opprettet av",
              options: uniqUsers.map((user) => {
                return {
                  value: user.value,
                  label: user.label,
                  isActive: selecetedUsers.includes(user.value),
                };
              }),
            },
          ]}
          clearAllFilters={() => setSelectedUsers([])}
          selectAllMultiFilter={() => setSelectedUsers(uniqUsers.map((user) => user.value))}
          resetMultiFilter={() => setSelectedUsers([])}
        >
          {storedData?.map((item) => {
            const comment: IComment = {
              _id: item._id,
              text: item.text,
              createdByName: item.createdByUser.name,
              createdAt: item.createdAt as string,
              deleted: item.deleted,
            };
            return (
              <SingleComment
                members={[]}
                key={comment._id}
                comment={comment}
                editEnabled={false}
                deleteEnabled={false}
                onSave={() => {}}
                onDelete={() => {}}
              />
            );
          })}
        </FreeTextSearch>
      )}
    </div>
  );
};

export default NewsSearch;
